import React from "react";

const CardIcon = ({ language }) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      version="1.1"
      viewBox="0 0 17 17"
      role="img"
      height="1em"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "6rem", height: "2rem" }}
      aria-hidden="true"
    >
      <g>
        <title>{language.card}</title>
      </g>
      <path d="M15.5 2h-14c-0.827 0-1.5 0.673-1.5 1.5v10c0 0.827 0.673 1.5 1.5 1.5h14c0.827 0 1.5-0.673 1.5-1.5v-10c0-0.827-0.673-1.5-1.5-1.5zM16 13.5c0 0.275-0.224 0.5-0.5 0.5h-14c-0.276 0-0.5-0.225-0.5-0.5v-5.5h15v5.5zM1 5v-1.5c0-0.275 0.224-0.5 0.5-0.5h14c0.276 0 0.5 0.225 0.5 0.5v1.5h-15z"></path>
    </svg>
  );
};

export default CardIcon;
